import React, { useState } from 'react';

function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const response = await fetch('http://localhost:5000/api/newsletter/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus(data.error || 'Failed to subscribe');
      }
    } catch (error) {
      setStatus('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newsletter-section">
      <div className="newsletter-container">
        <h3>📧 Get Best Deals in Your Inbox</h3>
        <p>Subscribe to receive exclusive coupons and latest offers!</p>
        
        <form onSubmit={handleSubmit} className="newsletter-form">
          <input
            type="email"
            placeholder="Enter your email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>

        {status && (
          <p className={`newsletter-status ${status === 'success' ? 'success' : 'error'}`}>
            {status === 'success' 
              ? '✓ Subscribed! Check your email for confirmation.' 
              : status}
          </p>
        )}
      </div>
    </div>
  );
}

export default Newsletter;
